<template>
  <dashboard-layout :loading="initialLoading" loading-text="正在加载伴侣">
    <div class="list-page">
      <div class="page-head">
        <div class="title-block">
          <h2>角色列表</h2>
          <p>你创造的每个角色，都是独一无二的陪伴</p>
        </div>
        <div class="actions">
          <el-input
            v-model="keyword"
            prefix-icon="el-icon-search"
            placeholder="搜索角色名称、标签..."
            class="search"
          />
          <el-button class="filter-btn" round @click="$router.push('/role-cards')">用角色卡创建</el-button>
          <el-button type="primary" round class="create-btn" @click="$router.push('/companion-editor')">+ 创建角色</el-button>
        </div>
      </div>

      <div class="tabs-row">
        <div class="tabs">
          <span
            v-for="t in tabList"
            :key="t.key"
            class="tab"
            :class="{ on: activeTab === t.key }"
            @click="activeTab = t.key"
          >{{ t.label }} {{ t.count }}</span>
        </div>
        <div class="view-ctrl">
          <el-select v-model="sortBy" size="small" class="sort">
            <el-option label="最近使用" value="recent" />
          </el-select>
          <span class="grid on"><i class="el-icon-menu"></i></span>
          <span class="list"><i class="el-icon-s-operation"></i></span>
        </div>
      </div>

      <div v-if="!displayList.length" class="empty-tip">{{ list.length ? "没有匹配的伴侣，换个关键词或筛选试试" : "还没有伴侣，去创建一个吧～" }}</div>
      <div class="grid">
        <div v-for="item in displayList" :key="item.id" class="card">
          <div class="cover">
            <img :src="item.avatar || require('@/assert/主页人物.png')" alt="" />
            <span class="like">♥ {{ item.likes }}</span>
            <span v-if="item.bound" class="wx"><i class="el-icon-chat-round"></i></span>
          </div>
          <div class="body">
            <h3>{{ item.name }}</h3>
            <p class="intro">{{ item.intro }}</p>
            <div class="tags">
              <span v-for="tag in item.tags" :key="tag">{{ tag }}</span>
            </div>
            <div class="relation">
              <i class="el-icon-star-on"></i>
              关系状态
              <em :class="{ friend: item.relation.includes('朋友') }">{{ item.relation }}</em>
            </div>
            <div class="wx-status" :class="{ on: item.bound }">
              <i class="el-icon-chat-round"></i>
              <template v-if="item.bound">已绑定微信号 {{ item.wechatId }}</template>
              <template v-else>未绑定微信</template>
            </div>
            <div class="btns">
              <el-button size="small" round @click="$router.push({ path: '/companion-detail', query: { id: item.id } })">查看详情</el-button>
              <el-button type="primary" size="small" round @click="$router.push({ path: '/chat', query: { id: item.id } })">开始聊天</el-button>
              <el-button size="small" round @click="$router.push({ path: '/role-card-editor', query: { id: item.roleCardId } })">查看角色</el-button>
              <el-dropdown trigger="click" @command="(cmd) => onCommand(cmd, item)">
                <el-button size="small" circle icon="el-icon-more" />
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="wechat"><i class="el-icon-chat-round"></i> 绑定微信号</el-dropdown-item>
                  <el-dropdown-item command="share"><i class="el-icon-share"></i> 私享分享</el-dropdown-item>
                  <el-dropdown-item command="delete" divided><span class="del-text">删除伴侣</span></el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </div>

    </div>

    <el-dialog
      :title="(bindCompanion ? bindCompanion.name : '') + ' · 微信号绑定'"
      :visible.sync="bindVisible"
      width="420px"
      custom-class="yw-dialog"
    >
      <div class="bind-mgr" v-if="bindVisible" v-loading="bindRowsLoading">
        <p class="hint">开关即可将该伴侣与微信号相互绑定 / 解绑。一个微信号可绑定多个伴侣。</p>
        <div v-for="row in bindRows" :key="row.wechatId" class="bind-row">
          <div class="info">
            <b>{{ row.nickname }}</b>
            <span>微信号 {{ row.wechatId }}</span>
          </div>
          <el-switch v-model="row.bound" active-color="#c94225" :disabled="bindBusy" @change="toggleBind(row)" />
        </div>
        <p v-if="!bindRows.length" class="empty">还没有微信号，请先到「微信号管理」扫码新增。</p>
      </div>
      <span slot="footer">
        <el-button round @click="$router.push('/wechat-accounts')">去扫码新增</el-button>
        <el-button type="primary" round @click="bindVisible = false">完成</el-button>
      </span>
    </el-dialog>
  </dashboard-layout>
</template>

<script>
import { companionApi, roleCardApi, wechatApi } from "@/services/api";
import DashboardLayout from "@/components/DashboardLayout.vue";

export default {
  name: "CompanionListView",
  components: { DashboardLayout },
  data() {
    return {
      keyword: "",
      sortBy: "recent",
      activeTab: "all",
      list: [],
      bindVisible: false,
      bindCompanion: null,
      bindRows: [],
      bindBusy: false,
      bindRowsLoading: false,
      initialLoading: true,
    };
  },
  computed: {
    tabList() {
      const bound = this.list.filter((c) => c.bound).length;
      return [
        { key: "all", label: "全部", count: this.list.length },
        { key: "mine", label: "我的角色", count: this.list.length },
        { key: "wx", label: "已绑定微信", count: bound },
      ];
    },
    displayList() {
      let arr = this.list;
      if (this.activeTab === "wx") arr = arr.filter((c) => c.bound);
      const kw = this.keyword.trim().toLowerCase();
      if (kw) {
        arr = arr.filter(
          (c) => c.name.toLowerCase().includes(kw) || (c.tags || []).join(",").toLowerCase().includes(kw)
        );
      }
      return arr;
    },
  },
  created() {
    this.load();
  },
  methods: {
    async load() {
      try {
        const [list, roleCards] = await Promise.all([
          companionApi.list(),
          roleCardApi.list().catch(() => []),
        ]);
        const roleCardMap = new Map((roleCards || []).map((rc) => [rc.id, rc]));
        this.list = (list || []).map((item) => this.mapCompanion(item, roleCardMap));
      } catch (e) {
        this.list = [];
        this.$message.error(e.message || "加载伴侣失败");
      } finally {
        this.initialLoading = false;
      }
    },
    mapCompanion(c, roleCardMap = new Map()) {
      const p = c.presentation || {};
      const bound = c.binding_status === "bound" && !!c.wechat_account_id;
      const roleCard = roleCardMap.get(c.role_card_id);
      return {
        id: c.id,
        roleCardId: c.role_card_id,
        name: c.name,
        intro: c.description || p.background_story || "暂无简介",
        tags: (p.traits && p.traits.length ? p.traits : [c.role_card_name]).filter(Boolean).slice(0, 3),
        relation: p.relationship_label || "初识",
        likes: p.intimacy !== null && p.intimacy !== undefined
          ? p.intimacy
          : (c.intimacy_base_level || 0),
        avatar: (roleCard && roleCard.reference_image_url) || "",
        bound,
        wechatId: c.wechat_account_id || "",
      };
    },
    async openBindDialog(item) {
      this.bindCompanion = item;
      this.bindRows = [];
      this.bindVisible = true;
      this.bindRowsLoading = true;
      try {
        const [accounts, bindings] = await Promise.all([
          wechatApi.list(),
          companionApi.wechatBindings(item.id),
        ]);
        const boundIds = new Set((bindings || []).map((b) => b.wechat_account_id));
        this.bindRows = (accounts || []).map((a) => ({
          wechatId: a.wechat_account_id,
          nickname: a.nickname || a.wechat_account_id,
          bound: boundIds.has(a.wechat_account_id),
        }));
      } catch (e) {
        this.$message.warning(e.message || "加载微信号失败");
      } finally {
        this.bindRowsLoading = false;
      }
    },
    async toggleBind(row) {
      if (this.bindBusy) return;
      this.bindBusy = true;
      try {
        if (row.bound) {
          await companionApi.bindWechat(this.bindCompanion.id, row.wechatId);
          this.$message.success("已绑定");
        } else {
          await companionApi.unbindWechat(this.bindCompanion.id, row.wechatId);
          this.$message.success("已解绑");
        }
        await this.load();
        const fresh = this.list.find((c) => c.id === this.bindCompanion.id);
        if (fresh) this.bindCompanion = fresh;
      } catch (e) {
        row.bound = !row.bound;
        this.$message.error(e.message || "操作失败");
      } finally {
        this.bindBusy = false;
      }
    },
    onCommand(cmd, item) {
      if (cmd === "wechat") {
        this.openBindDialog(item);
      } else if (cmd === "share") {
        this.$router.push("/role-cards");
      } else if (cmd === "delete") {
        this.$confirm(`确定删除伴侣「${item.name}」吗？该操作不可恢复。`, "删除伴侣", {
          type: "warning",
          confirmButtonText: "确定删除",
          cancelButtonText: "取消",
        })
          .then(async () => {
            try {
              await companionApi.remove(item.id);
              this.list = this.list.filter((c) => c.id !== item.id);
              this.$message.success("已删除");
            } catch (e) {
              this.$message.error(e.message || "删除失败");
            }
          })
          .catch(() => {});
      }
    },
  },
};
</script>

<style scoped lang="scss">
.list-page {
  .empty-tip {
    padding: 60px 0;
    text-align: center;
    color: #bbb;
    font-size: 14px;
  }

  .page-head {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 20px;

    .title-block {
      h2 {
        margin: 0 0 6px;
        font-size: 26px;
        font-weight: 700;
        color: #1a1a1a;
      }

      p {
        margin: 0;
        color: #999;
        font-size: 13px;
      }
    }

    .actions {
      display: flex;
      align-items: center;
      gap: 10px;

      .search {
        width: 280px;

        ::v-deep .el-input__inner {
          height: 40px;
          border-radius: 20px;
          border-color: #e8e3ed;
          background: #fff;
        }
      }

      .filter-btn {
        color: #7255e9;
        border-color: #ded6ff;
      }

      .create-btn {
        padding: 10px 20px;
        border: 0;
        background: linear-gradient(90deg, #c94225, #7255e9);
      }
    }
  }

  .tabs-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    .tabs {
      display: flex;
      gap: 8px;

      .tab {
        padding: 8px 18px;
        border-radius: 20px;
        color: #666;
        font-size: 13px;
        cursor: pointer;
        background: #fff;
        transition: 0.2s;

        &:hover {
          color: #7255e9;
        }

        &.on {
          color: #fff;
          background: linear-gradient(90deg, #c94225, #7255e9);
          box-shadow: 0 6px 16px rgba(114, 85, 233, 0.28);
        }
      }
    }

    .view-ctrl {
      display: flex;
      align-items: center;
      gap: 8px;

      .sort {
        width: 110px;
      }

      .grid,
      .list {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 32px;
        height: 32px;
        border-radius: 8px;
        color: #999;
        cursor: pointer;
        background: #fff;

        &.on {
          color: #7255e9;
          background: #f1edff;
        }
      }
    }
  }

  .grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 18px;

    .card {
      position: relative;
      aspect-ratio: 0.618 / 1;
      border-radius: 18px;
      background: #eeeafe;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);
      overflow: hidden;
      transition: transform 0.25s, box-shadow 0.25s;

      &:hover {
        transform: translateY(-4px);
        box-shadow: 0 12px 32px rgba(114, 85, 233, 0.16);
      }

      &:hover .cover img {
        transform: scale(1.05);
      }

      .cover {
        position: absolute;
        inset: 0;
        height: auto;
        background: linear-gradient(180deg, #eeeafe 0%, #ded6ff 100%);

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center top;
          transition: transform 0.4s;
        }

        .like {
          position: absolute;
          left: 12px;
          top: 12px;
          padding: 4px 10px;
          border-radius: 14px;
          color: #fff;
          font-size: 12px;
          background: rgba(0, 0, 0, 0.35);
        }

        .wx {
          position: absolute;
          right: 12px;
          top: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 28px;
          height: 28px;
          border-radius: 50%;
          color: #fff;
          font-size: 14px;
          background: #07c160;
        }
      }

      .body {
        position: absolute;
        left: 10px;
        right: 10px;
        bottom: 10px;
        padding: 12px;
        border: 1px solid rgba(255, 255, 255, 0.64);
        border-radius: 14px;
        background: rgba(255, 255, 255, 0.78);
        backdrop-filter: blur(14px);
        box-shadow: 0 12px 28px rgba(25, 10, 18, 0.12);

        h3 {
          margin: 0 0 6px;
          font-size: 17px;
          font-weight: 700;
        }

        .intro {
          margin: 0 0 10px;
          min-height: 36px;
          color: #999;
          font-size: 12px;
          line-height: 1.5;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }

        .tags {
          display: flex;
          flex-wrap: wrap;
          gap: 6px;
          margin-bottom: 10px;

          span {
            padding: 2px 10px;
            border-radius: 10px;
            color: #816bef;
            font-size: 11px;
            background: #f7f4ff;
          }
        }

        .relation {
          margin-bottom: 12px;
          color: #bbb;
          font-size: 11px;

          i {
            margin-right: 2px;
            color: #ffc0d8;
          }

          em {
            margin-left: 4px;
            color: #7255e9;
            font-style: normal;

            &.friend {
              color: #52c41a;
            }
          }
        }

        .wx-status {
          margin-bottom: 12px;
          color: #bbb;
          font-size: 11px;

          i {
            margin-right: 3px;
          }

          &.on {
            color: #07c160;
          }
        }

        .btns {
          display: flex;
          gap: 6px;
          align-items: center;
          flex-wrap: wrap;

          .el-button--primary {
            border: 0;
            background: linear-gradient(90deg, #c94225, #7255e9);
          }
        }
      }
    }
  }

  .pager {
    display: flex;
    justify-content: center;
    margin-top: 28px;

    ::v-deep .el-pager li.active {
      color: #7255e9;
    }

    ::v-deep .el-pagination button:hover,
    ::v-deep .el-pager li:hover {
      color: #7255e9;
    }
  }

  @media (max-width: 768px) {
    .page-head {
      flex-wrap: wrap;
      gap: 10px;

      .actions {
        width: 100%;
        flex-wrap: wrap;

        .search {
          width: 100%;
        }
      }
    }

    .tabs-row {
      flex-wrap: wrap;
      gap: 8px;

      .tabs {
        width: 100%;
        overflow-x: auto;

        .tab {
          flex-shrink: 0;
          padding: 7px 14px;
        }
      }
    }

    .grid {
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 10px;
    }
  }
}

.bind-mgr {
  .hint {
    margin: 0 0 14px;
    color: #999;
    font-size: 12px;
  }

  .bind-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    border-bottom: 1px solid #f5f0f2;

    .info {
      b {
        display: block;
        font-size: 14px;
      }

      span {
        color: #aaa;
        font-size: 12px;
      }
    }
  }

  .empty {
    margin: 0;
    padding: 16px 0;
    text-align: center;
    color: #bbb;
    font-size: 13px;
  }
}
</style>

<style scoped lang="scss">
.list-page {
  min-width: 0;

  .empty-tip,
  .page-head .title-block p,
  .grid .card .body .intro,
  .grid .card .body .relation,
  .grid .card .body .wx-status {
    color: var(--xyo-muted);
  }

  .page-head {
    min-width: 0;

    .title-block {
      min-width: 0;

      h2 {
        color: var(--xyo-ink-strong);
      }
    }

    .actions {
      min-width: 0;

      .search ::v-deep .el-input__inner {
        border-color: var(--xyo-line-strong);
        background: var(--xyo-surface-raised);
      }

      .filter-btn {
        color: var(--xyo-primary);
        border-color: var(--xyo-line-strong);
        background: var(--xyo-surface-raised);
      }

      .create-btn {
        background: var(--xyo-primary);
      }
    }
  }

  .tabs-row {
    min-width: 0;

    .tabs .tab {
      color: var(--xyo-ink-soft);
      border: 1px solid var(--xyo-line);
      background: var(--xyo-surface-raised);

      &:hover {
        color: var(--xyo-primary);
        border-color: var(--xyo-primary);
      }

      &.on {
        color: #fff;
        border-color: var(--xyo-primary);
        background: var(--xyo-primary);
        box-shadow: none;
      }
    }

    .view-ctrl {
      min-width: 0;

      .grid,
      .list {
        color: var(--xyo-muted);
        border: 1px solid var(--xyo-line);
        background: var(--xyo-surface-raised);

        &.on {
          color: var(--xyo-primary);
          border-color: var(--xyo-line-strong);
          background: var(--xyo-accent-pale);
        }
      }
    }
  }

  .grid .card {
    background: var(--xyo-surface-muted);

    &:hover {
      box-shadow: var(--xyo-shadow-lg);
    }

    .cover {
      background: var(--xyo-surface-muted);
    }

    .body {
      border-color: var(--xyo-line);
      background: var(--xyo-surface-raised);

      .tags span {
        color: var(--xyo-primary);
        background: var(--xyo-accent-pale);
      }

      .relation {
        i,
        em {
          color: var(--xyo-primary);
        }

        em.friend {
          color: var(--xyo-success);
        }
      }

      .wx-status.on {
        color: var(--xyo-success);
      }

      .btns .el-button--primary {
        background: var(--xyo-primary);
      }
    }
  }

  .pager {
    ::v-deep .el-pager li.active,
    ::v-deep .el-pagination button:hover,
    ::v-deep .el-pager li:hover {
      color: var(--xyo-primary);
    }
  }
}

.bind-mgr {
  .hint,
  .bind-row .info span,
  .empty {
    color: var(--xyo-muted);
  }

  .bind-row {
    border-bottom-color: var(--xyo-line);
  }
}

@media (max-width: 768px) {
  .list-page {
    max-width: 100%;

    .page-head .actions,
    .page-head .actions .search,
    .tabs-row,
    .tabs-row .tabs,
    .tabs-row .view-ctrl,
    .grid {
      min-width: 0;
      max-width: 100%;
    }

    .grid {
      grid-template-columns: minmax(0, 1fr);
    }
  }
}
</style>
